module.exports = __webpack_public_path__ + "img/info.1faa1ebd.svg";